<template>
  <collapsed-card icon="md-calendar" title="Календарный план">
    <inline-loader :loading="loading" v-if="loading" />
    <div class="contract-roadmap" v-else>
      <i-table
        no-data-text="Этапы отсутствуют"
        border
        :columns="columns"
        :data="roadmap"
        :disabled-hover="true"
        show-summary
        :summary-method="handleSummary"
      />
    </div>

    <i-button
      type="text"
      class="collapsed-card-button ms-link"
      slot="dropdown"
      @click="editClickHandler"
      v-if="getContractModulePerms('contract_info', 'update')"
    >
      Редактировать
    </i-button>

    <modal
      v-model="editModal"
      width="1120"
      :styles="{ top: '40px' }"
      :mask-closable="false"
    >
      <div slot="header" class="law-cases-editor__header">
        <icon size="16" type="md-calendar" class="ms-help" />
        <span style="margin-left: 4px" class="ms-help">
          Редактирование календарного плана
        </span>
      </div>
      <contract-roadmap
        v-if="editModal"
        :contract="editingContract"
        :editing="true"
      />
      <div slot="footer" class="contract-subinfo-edit">
        <i-button
          type="success"
          size="small"
          :disabled="isSavingDisabled"
          :loading="saving"
          @click="save"
        >
          Сохранить
        </i-button>
      </div>
    </modal>
  </collapsed-card>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import CollapsedCard from '@/components/parts/collapsed-card'
import InlineLoader from '@/components/loaders/inline-loader'
import ContractRoadmap from '@/components/contract-editor/steps/roadmap'
import ContractRoadmapName from './contract-roadmap-name'
import {
  getFormattedCosts,
  isRoadmapInvalid,
  getSummaryRow,
  formatDefaultDate,
  modifyRoadmapsDates
} from '@/utils'

const getColumns = (comp) => [
  { title: '№', width: 64, align: 'center', key: 'number' },
  {
    title: 'Наименование',
    key: 'name',
    render: (h, params) => {
      return h(ContractRoadmapName, {
        props: {
          roadmap: params.row
        }
      })
    }
  },
  {
    title: 'Начало',
    key: 'start_date',
    width: 80,
    render: (h, params) => {
      return h('span', formatDefaultDate(params.row.start_date))
    }
  },
  {
    title: 'Окончание',
    key: 'end_date',
    width: 102,
    render: (h, params) => {
      return h('span', formatDefaultDate(params.row.end_date))
    }
  },
  {
    title: comp.$store.state.contracts.current.with_vat
      ? 'Сумма с НДС'
      : 'Сумма без НДС',
    key: 'costs',
    width: 140,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.costs, true))
    }
  }
]

export default {
  components: {
    CollapsedCard,
    InlineLoader,
    ContractRoadmap
  },
  data () {
    return {
      loading: false,
      roadmap: [],
      editingContract: {
        roadmaps: []
      },
      editModal: false,
      saving: false,
      columns: getColumns(this)
    }
  },
  watch: {
    '$route.query.amendment_id': function (value) {
      this.getData()
    },
    editModal: function (value) {
      if (!value) this.getEditingData()
    }
  },
  computed: {
    withVat () {
      return this.$store.state.contracts.current.with_vat
    },
    isSavingDisabled () {
      if (
        this.editingContract.roadmaps
          .filter((r) => !r.is_retention)
          .some(isRoadmapInvalid)
      ) {
        return true
      }

      return false
    }
  },
  methods: {
    async getData () {
      const { id } = this.$route.params
      const { amendment_id } = this.$route.query

      try {
        this.loading = true
        let url = `page/roadmap?contract_id=${id}`
        if (amendment_id) url += `&amendment_id=${amendment_id || ''}`
        this.roadmap = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async getEditingData () {
      const roadmaps = cloneDeep(
        this.roadmap.map((r) => ({
          ...r,
          start_date: formatDefaultDate(r.start_date),
          end_date: formatDefaultDate(r.end_date)
        }))
      )
      this.$set(this, 'editingContract', { roadmaps })
    },
    async editClickHandler () {
      await this.getEditingData()
      this.editModal = true
    },
    async save () {
      const { id } = this.$route.params
      const { amendment_id } = this.$route.query

      try {
        this.saving = true
        let url = `page/roadmap?contract_id=${id}`
        if (amendment_id) url += `&amendment_id=${amendment_id}`
        const data = this.getSavingData()
        await this.$store.dispatch('POST_REQUEST', { url, data })
        this.$emit('update')
        await this.getData()
        this.$Message.success('Сохранение данных выполнено успешно')
        this.editModal = false
        this.saving = false
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при сохранении данных')
        this.saving = false
      }
    },
    getSavingData () {
      const { roadmaps } = this.editingContract

      return modifyRoadmapsDates(roadmaps)
    },
    handleSummary (payload) {
      return getSummaryRow(payload, [4])
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less">
.contract-roadmap {
  tbody {
    td {
      height: 28px;

      .ivu-table-cell {
        padding-left: 8px;
        padding-right: 8px;
      }
    }
  }
}
</style>
